import "./BenefitCard.css";
import discountIcon from "../../images/discountIcon.svg";
import { ArrowRight } from 'lucide-react';

export default function BenefitCard({ text, value, onClick }) {

    return (
        < div className="benefit-card-container" >
            <span className="benefit-card-title">Os meus benefícios</span>
            <button
                type="button"
                className="benefit-card"
                onClick={onClick}
            >
                <div className="benefit-card__icon-container">
                    {
                        value > 0 && (
                            <img
                                src={discountIcon}
                                alt="Programa de Descontos"
                                className="benefit-card__icon"
                            />
                        )
                    }
                </div >
                <div className="benefit-card__content">
                    <span className="benefit-card__title">
                        {value > 0 ? "PROGRAMA DE DESCONTOS" : "PROGRAMA DE VANTAGENS"}
                    </span>

                    <span className="benefit-card__description">
                        {text}
                    </span >
                    <span className="benefit-card__value">
                        {value > 0 && (new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value))}
                    </span>
                    <div className="benefit-card__novalue">
                        {value == 0 && (
                            <div className="benefit-card__novalue">
                                <h6>Ver benefícios</h6>
                                <ArrowRight color="#CE4100" />
                            </div>
                        )}
                    </div>
                </div >
            </button >
        </div >
    );
}